package com.yogaaicoach.pages.trainingprogram

import com.yogaaicoach.common.ui.components.ChevronDownIcon
import react.ChildrenBuilder
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.img
import react.dom.html.ReactHTML.span
import react.useState
import web.cssom.ClassName
import web.html.ButtonType
import web.html.button as buttonType

// Row layout: image (optional, left) | title column (flex: 1) | chevron button (right, when description present).
// Tapping the row body selects/deselects. Tapping the chevron expands/collapses the description inline.
internal fun ChildrenBuilder.AddTrainingRow(
    image: String?,
    title: String,
    description: String?,
    isSelected: Boolean,
    onRowClick: () -> Unit,
) {
    var expanded by useState(false)

    div {
        className = ClassName(if (isSelected) "add-training-row add-training-row-selected" else "add-training-row")
        onClick = { onRowClick() }
        image?.let {
            img { className = ClassName("add-training-row-image"); src = it; alt = "" }
        }
        div {
            className = ClassName(if (image == null) "add-training-row-title add-training-row-title-no-image" else "add-training-row-title")
            span { className = ClassName("add-training-row-title-text"); +title }
            if (expanded && description != null) {
                span { className = ClassName("add-training-row-description"); +description }
            }
        }
        if (description != null) {
            button {
                type = ButtonType.buttonType
                className = ClassName(if (expanded) "add-training-row-expand-btn expanded" else "add-training-row-expand-btn")
                onClick = { event ->
                    event.stopPropagation()
                    expanded = !expanded
                }
                ChevronDownIcon {}
            }
        }
    }
}
